import { format, parse, isValid } from "date-fns";

export const DISPLAY_FORMAT = "dd/MM/yyyy HH:mm";

export function formatDisplay(iso: string | null | undefined): string {
  if (!iso) return "";
  const d = new Date(iso);
  return isValid(d) ? format(d, DISPLAY_FORMAT) : "";
}

export function parseDisplay(text: string): { iso: string | null; valid: boolean } {
  const trimmed = text.trim();
  if (trimmed === "") return { iso: null, valid: true };
  const parsed = parse(trimmed, DISPLAY_FORMAT, new Date());
  if (!isValid(parsed)) return { iso: null, valid: false };
  if (format(parsed, DISPLAY_FORMAT) !== trimmed) return { iso: null, valid: false };
  return { iso: parsed.toISOString(), valid: true };
}
